import React, { Component } from 'react';
import { pageDefinition } from 'site-modules/shared/pages/page';
import { TrackingHandler } from 'client/tracking/handler';
import { CommonMap } from 'client/tracking/maps/common/index';
import { ERROR_PAGES } from 'site-modules/shared/constants/error-page-names';
import { NOT_FOUND_SEO_CONTEXT } from 'site-modules/shared/pages/seo';
import { NotFoundLayout } from 'site-modules/shared/components/not-found-layout/not-found-layout';
import { EdmundsCpaNoAdhesionDecorator } from 'site-modules/shared/pages/decorators/edmunds-cpa-no-adhesion';

export class NotFoundUI extends Component {
  componentDidMount() {
    TrackingHandler.useMap(CommonMap);
  }

  render() {
    return <NotFoundLayout />;
  }
}

export default pageDefinition({
  name: ERROR_PAGES.notFound,
  category: 'venom',
  seo: NOT_FOUND_SEO_CONTEXT,
  component: NotFoundUI,
  decorator: EdmundsCpaNoAdhesionDecorator,
});
